<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" :rules="rules" ref="form">
      <el-form-item label="参数编码" required>
        <el-input maxlength="50" v-model="form.code" placeholder="请输入参数编码" v-trim/>
      </el-form-item>
      <el-form-item label="参数名称" required>
        <el-input maxlength="50" v-model="form.name" placeholder="请输入参数名称" v-trim/>
      </el-form-item>
      <el-form-item v-for="field in fields" :key="field.variable" :label="field.name">
        <el-input type="textarea"  v-model="form[field.variable]" :placeholder="'请输入' + field.name" v-trim/>
      </el-form-item>
      <el-form-item label="备注">
        <el-input type="textarea" maxlength="200" show-word-limit v-model="form.remark" placeholder="请输入备注" v-trim/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaParameterWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      type: null,
      fields: [],
      form: {
        // id
        id: null
      },
      // 验证规则
      rules: {
        code: [
          { required: true, message: '请输入参数编码' }
        ],
        name: [
          { required: true, message: '请输入参数名称' }
        ]
      }
    }
  },
  methods: {
    /**
     * 打开窗口
     *
     * @param title 窗口标题
     * @param target 行对象（仅编辑需该参数）
     * @param type 参数类型对象
     */
    open (title, type, target) {
      this.title = title
      this.type = type
      this.visible = true
      const fields = JSON.parse(type.fieldConfig)
      this.fields = fields
      // 构建动态form
      this.form = { id: null, code: '', name: '', remark: '' }
      for (const field of fields) {
        this.$set(this.form, field.variable, '')
      }
      // 编辑
      if (target != null) {
        this.$nextTick(() => {
          for (const key in this.form) {
            this.form[key] = target[key]
          }
        })
      }
    },
    /**
     * 确认（点击确认按钮后触发）
     */
    confirm () {
      const value = {}
      for (const field of this.fields) {
        value[field.variable] = this.form[field.variable]
      }
      const param = {
        id: this.form.id,
        typeId: this.type.id,
        code: this.form.code,
        name: this.form.name,
        value: JSON.stringify(value),
        remark: this.form.remark
      }
      if (this.form[this.configData['field.id']] == null || this.form[this.configData['field.id']] === '') {
        this.__confirmCreate(param)
        return
      }
      this.__confirmEdit(param)
    }
  },
  created () {
    this.config({
      api: '/template/parameter'
    })
  }
}
</script>

<style scoped>

</style>
